import { render } from "./IndividualSalesWizardChart.vue?vue&type=template&id=08fcfd74"
import script from "./IndividualSalesWizardChart.vue?vue&type=script&lang=js"
export * from "./IndividualSalesWizardChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__